import Router from "vue-router";
import Home from "../views/Home.vue";
import Vue from 'vue'
Vue.use(Router)

const routes = [{
    path: '/',
    redirect: '/homepage'
}, {
    path: "/",
    name: "Home",
    component: Home,
    children: [{
        path: "/homepage",
        name: "homepage",
        meta: {
            title: '首页'
        },
        component: () => import(
            /* webpackChunkName: "dashboard" */
            "../views/homepage.vue")
    },{
        path: "/table2",
        name: "table2",
        meta: {
            title: '新闻资讯'
        },
        component: () => import(
            /* webpackChunkName: "dashboard" */
            "../views/table2.vue")
    },{
        path: "/InternetofThings",
        name: "InternetofThings",
        meta: {
            title: '产品中心'
        },
        component: () => import(
            /* webpackChunkName: "dashboard" */
            "../views/InternetofThings.vue")
    },{
        path: "/Solution",
        name: "Solution",
        meta: {
            title: '解决方案'
        },
        component: () => import(
            /* webpackChunkName: "dashboard" */
            "../views/Solution.vue")
    },{
        path: "/cases",
        name: "cases",
        meta: {
            title: '关键产品'
        },
        component: () => import(
            /* webpackChunkName: "dashboard" */
            "../views/cases.vue")
    },{
        path: "/downloadCenter",
        name: "downloadCenter",
        meta: {
            title: '服务与支持'
        },
        component: () => import(
            /* webpackChunkName: "dashboard" */
            "../views/downloadCenter.vue")
    },{
        path: "/JoinUs",
        name: "JoinUs",
        meta: {
            title: '加入小之'
        },
        component: () => import(
            /* webpackChunkName: "dashboard" */
            "../views/JoinUs.vue")
    },{
        path: "/administration",
        name: "administration",
        meta: {
            title: '系统管理'
        },
        component: () => import(
            /* webpackChunkName: "dashboard" */
            "../views/administration.vue")
    }]
}, {
    path: "/login",
    name: "Login",
    meta: {
        title: '登录'
    },
    component: () => import(
        /* webpackChunkName: "login" */
        "../views/Login.vue")
}];

const router =  new Router({
    mode:'hash',
    routes
});

router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | 深圳市志为科技有限公司`;
    const role = localStorage.getItem('ms_username');
    if (!role && to.path !== '/login') {
        next('/login');
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ?
            next() :
            next('/403');
    } else {
        next();
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js